@if (workspaceId !== EWorkspaces.OVERVIEW) {
  <pp-saved-views-dropdown-switch
    [(ppSelectedOption)]="selectedOption"
    [ppWorkspaceId]="workspaceId"
    [ppSavedViews]="savedViews"
  ></pp-saved-views-dropdown-switch>
}

@if (savedViews) {
  <pp-saved-views-list
    [ppType]="selectedOption"
    [ppInjectedDropdownService]="injectedDropdownService"
    [ppSavedViews]="savedViews"
    [ppNoSwitchVisible]="workspaceId === EWorkspaces.OVERVIEW"
    >
  </pp-saved-views-list>
}

<footer>
  @if (savedViews) {
    <hr class="savedViews__hr" />
  }

  <div class="savedViews__buttons-container">
    <pp-saved-views-dropdown-new-view-button
      [ppType]="selectedOption"
      [ppWorkspaceId]="workspaceId"
    ></pp-saved-views-dropdown-new-view-button>

    <pp-saved-views-done-button></pp-saved-views-done-button>
  </div>
</footer>
